import { takeLatest, call, put } from 'redux-saga/effects';
import * as employeeActions from 'redux/ducks/Employee/EmployeeDucks';
import * as termsActions from 'redux/ducks/Terms/TermsDucks';

import employeeApi from 'api/employee/employeeApi';
import employeeNoSessionApi from 'api/employee/employeeNoSessionApi';
import * as alertActions from 'redux/ducks/common/alertDucks';
import * as popupActions from 'redux/ducks/common/popupDucks';

export function* getNationTelCodeList() {
  try {
    const response = yield call(employeeApi.getNationTelCodeList, {});
    yield put(employeeActions.getNationTelCodeListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
  }
}

export function* duplicateIdCheck({ payload }) {
  try {
    const response = yield call(employeeApi.duplicateIdCheck, payload);
    yield put(employeeActions.duplicateIdCheckSuccess({ employeeId: payload.query, response }));
  } catch (error) {
    yield put(employeeActions.duplicateIdCheckFail(error));
  }
}

export function* createAccount({ payload }) {
  try {
    const response = yield call(employeeApi.createAccount, payload);
    yield put(employeeActions.createAccountSuccess(response));
    yield put(termsActions.setTermsEpid(response.epid));
    yield put(popupActions.closeProgressPopup());
  } catch (error) {
    yield put(popupActions.closeProgressPopup());
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
    yield put(employeeActions.createAccountFail(error));
  }
}

export function* getDriveDomain({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.getNosessionProperty, payload);
    yield put(employeeActions.getDriveDomainSuccess(response.value));
  } catch (error) {
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
  }
}

export function* getMeetingDomain({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.getNosessionProperty, payload);
    yield put(employeeActions.getMeetingDomainSuccess(response.value));
  } catch (error) {
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
  }
}
export default function* EmployeeSaga() {
  yield takeLatest(employeeActions.getNationTelCodeList, getNationTelCodeList);
  yield takeLatest(employeeActions.duplicateIdCheck, duplicateIdCheck);
  yield takeLatest(employeeActions.createAccount, createAccount);
  yield takeLatest(employeeActions.getDriveDomain, getDriveDomain);
  yield takeLatest(employeeActions.getMeetingDomain, getMeetingDomain);
}
